module.exports = __webpack_public_path__ + "static/media/tcwgraphic.0be5fd8d.png";